import React, { useMemo } from "react";
import { useI18n } from "../../hooks/i18n-hooks";
import { useQuery } from "@apollo/client/react";
import { FIND_MY_INVOICES } from "../../graphql/invoices";
import LoadingBoundary from "../../ui_atoms/LoadingBoundary";
import NoSalariesImage from "../../assets/images/no-salaries-image.svg";
import EmptyScreen from "../../components/EmptyScreen";
import ScreenCard from "../ScreenCard";
import InvoiceItem from "../../components/InvoiceItem";
import Loading from "../../components/Loading";
import { usePagination } from "../../hooks/use-pagination";
import { useBusinessEmailVerificationHeadband } from "../../hooks/use-business-email-verification-headband";

// One year of monthly invoices per page.
const INVOICES_PAGE_SIZE = 12;

export default function ClientInvoicesScreen() {
    const i18n = useI18n();
    const emailVerificationHeadband = useBusinessEmailVerificationHeadband();
    const { loading, error, data, refetch, fetchMore } = useQuery(FIND_MY_INVOICES, {
        fetchPolicy: "cache-and-network",
        variables: { limit: INVOICES_PAGE_SIZE },
    });

    const myInvoices = useMemo(
        () => data?.findMyInvoices.elements || [],
        [data?.findMyInvoices.elements],
    );

    const pagination = usePagination({ fetchMore });

    const isInitialLoading = loading && !data;

    return (
        <ScreenCard
            refresh={refetch}
            headband={emailVerificationHeadband}
            pagination={pagination}
            isContentContainerFlex={myInvoices.length === 0 || isInitialLoading}
        >
            <LoadingBoundary
                error={error}
                loading={loading && !data}
                clearError={() => {
                    void refetch();
                }}
            >
                {isInitialLoading ? (
                    <Loading />
                ) : myInvoices.length == 0 ? (
                    <EmptyScreen
                        image={NoSalariesImage}
                        text={i18n.t("screens.client_profile.tabs.invoices.no_invoices")}
                    />
                ) : (
                    myInvoices.map((invoice) => <InvoiceItem key={invoice.id} invoice={invoice} />)
                )}
            </LoadingBoundary>
        </ScreenCard>
    );
}
